/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React, { useEffect } from "react"
import PropTypes from "prop-types"
import styled, { ThemeProvider } from "styled-components"
import Helmet from "react-helmet"

import Theme from "../styles/Theme"

import Header from "./header"
import Footer from "./sections/footer"
import "./layout.css"

const SiteRoot = styled.div`
  background: white;
  margin-top: -100px;
`

const Layout = ({ children }) => {
    useEffect(() => {
    // jQuery
    const jquery = document.createElement("script")
    jquery.src = "https://code.jquery.com/jquery-3.6.0.min.js"
    jquery.async = true

    // colorbox
    const colorbox = document.createElement("script")
    colorbox.src =
      "https://wordpress.aventura.turystyka.pl/js/jquery.colorbox.js?ver=1.0.0"
    colorbox.async = true

    // docready
    const docready = document.createElement("script")
    docready.src =
      "https://wordpress.aventura.turystyka.pl/js/docready.js?ver=1.0.0"
    docready.async = true

    document.body.appendChild(jquery)
    document.body.appendChild(colorbox)
    document.body.appendChild(docready)
  }, [])

  return (
    <SiteRoot>
      <Helmet title="Aventura">
        <link rel="preconnect" href="https://datocms-assets.com" />
      </Helmet>
      <ThemeProvider theme={Theme}>
        <>
          <Header />
          <main>{children}</main>
          <Footer/>
        </>
      </ThemeProvider>
    </SiteRoot>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
